'use client';

import { Trans, t } from '@lingui/macro';
import { Close, Message } from '@mui/icons-material';
import { Avatar, Badge, Box, CircularProgress, IconButton, Paper, Popover, Popper, Stack, Tooltip, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useHubspot } from '../../../hooks/use-hubspot';
export const Chat = () => {
  const {
    chatIsVisible,
    openChat,
    closeChat,
    unreadCount
  } = useHubspot();
  const btnEl = useRef<any>(undefined);
  const [forceCloseSupport, setForceCloseSupport] = useState<boolean>(false);
  const [anchorElSupport, setAnchorElSupport] = useState<HTMLElement | undefined>(undefined);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);
  useEffect(() => {
    if (chatIsVisible && !!btnEl.current) {
      setAnchorEl(btnEl.current);
      setForceCloseSupport(true);
    } else {
      setAnchorEl(undefined);
    }
  }, [chatIsVisible, btnEl.current]);
  useEffect(() => {
    if (!!btnEl.current && !anchorElSupport && !forceCloseSupport) {
      setAnchorElSupport(btnEl.current);
    }
  }, [anchorElSupport, btnEl, forceCloseSupport]);
  const open = Boolean(anchorEl);
  const openSupport = !forceCloseSupport && Boolean(anchorElSupport);
  return <>
      <Tooltip title={t`Chat d'aide à l'utilisation`} placement="top" data-sentry-element="Tooltip" data-sentry-source-file="chat.tsx">
        <IconButton ref={btnEl} color="primary" onClick={openChat} data-sentry-element="IconButton" data-sentry-source-file="chat.tsx">
          <Badge badgeContent={unreadCount} color="error" data-sentry-element="Badge" data-sentry-source-file="chat.tsx">
            <Message data-sentry-element="Message" data-sentry-source-file="chat.tsx" />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover open={open} anchorEl={anchorEl} onClose={closeChat} anchorOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }} transformOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }} keepMounted data-sentry-element="Popover" data-sentry-source-file="chat.tsx">
        <Box component="div" height="530px" width="400px" maxHeight="100vh" maxWidth="100vw" position="relative" data-sentry-element="Box" data-sentry-source-file="chat.tsx">
          <Stack alignItems="center" justifyContent="center" sx={{
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          position: 'absolute',
          zIndex: 0
        }} data-sentry-element="Stack" data-sentry-source-file="chat.tsx">
            <CircularProgress data-sentry-element="CircularProgress" data-sentry-source-file="chat.tsx" />
          </Stack>
          <Box component="div" id="hs-chat-element-custom" position="relative" width="100%" height="100%" zIndex={10} data-sentry-element="Box" data-sentry-source-file="chat.tsx" />
        </Box>
      </Popover>
      <Popper open={openSupport} anchorEl={anchorElSupport} placement="top" sx={{
      zIndex: 10000000000000
    }} data-sentry-element="Popper" data-sentry-source-file="chat.tsx">
        <Paper elevation={4} data-sentry-element="Paper" data-sentry-source-file="chat.tsx">
          <Box component="div" padding={2} paddingTop={4} margin={1} borderRadius={2} bgcolor="white" width="250px" position="relative" data-sentry-element="Box" data-sentry-source-file="chat.tsx">
            <Avatar sx={{
            top: 0,
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute'
          }} src="/assets/marketing/florian-m-avatar.webp" data-sentry-element="Avatar" data-sentry-source-file="chat.tsx" />
            <IconButton onClick={() => setForceCloseSupport(true)} sx={{
            top: 0,
            right: 0,
            position: 'absolute'
          }} size="small" data-sentry-element="IconButton" data-sentry-source-file="chat.tsx">
              <Close color="gray" fontSize="small" data-sentry-element="Close" data-sentry-source-file="chat.tsx" />
            </IconButton>
            <Typography textAlign="center" data-sentry-element="Typography" data-sentry-source-file="chat.tsx">
              <Trans data-sentry-element="Trans" data-sentry-source-file="chat.tsx">
                Bonjour, je suis Florian de PRISMO 👋. Si vous rencontrez des
                problèmes dans l'utilisation de PRISMO App, je peux vous aider.
              </Trans>
            </Typography>
          </Box>
        </Paper>
      </Popper>
    </>;
};